//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "QAuModelTreeItemLight",
    inject: ["tree"],
    props: {
        node: { type: Object },
        depth: { type: Number, default: 0 },
        indent: { type: Number, default: 0 }
    },
    data() {
        return {
            localExpand: null
        };
    },
    computed: {
        meta() {
            return this.tree.meta[this.node.key];
        },
        expanded() {
            return this.localExpand === null ? this.node.children && this.node.children.length : this.localExpand;
        },
        itemIndent() {
            return this.indent + (this.node.group ? 0 : 1);
        },
        itemEntryIconName() {
            let icon = "mdi-circle-small";
            if ((this.node.children && this.node.children.length) || this.node.hasChildren) {
                icon = "mdi-menu-right";
            }
            return icon;
        },
        itemClasses() {
            return {
                "tree-root": this.depth === 0,
                open: this.expanded
            };
        },
        itemStyle() {
            return {
                "padding-left": `${20 * this.indent}px`
            };
        }
    },
    methods: {
        onClickItemEntry() {
            this.localExpand = !this.expanded;
        }
    }
};
